/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AnimationRouteImport } from './routes/animation'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ScanSpikeRouteImport } from './routes/scan-spike'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthRecoveryRouteImport } from './routes/_auth/recovery'
import { Route as AuthWelcomeRouteImport } from './routes/_auth/welcome'
import { Route as AuthenticatedExamsRouteImport } from './routes/_authenticated/exams'
import { Route as AuthenticatedFinanceRouteImport } from './routes/_authenticated/finance'
import { Route as AuthenticatedJournRouteImport } from './routes/_authenticated/journ'
import { Route as AuthenticatedMetricsRouteImport } from './routes/_authenticated/metrics'
import { Route as AuthenticatedPetsRouteImport } from './routes/_authenticated/pets'
import { Route as AuthenticatedPomodoroRouteImport } from './routes/_authenticated/pomodoro'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedShoppingRouteImport } from './routes/_authenticated/shopping'
import { Route as AuthenticatedWorldRouteImport } from './routes/_authenticated/world'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as AuthenticatedExamsIndexRouteImport } from './routes/_authenticated/exams/index'
import { Route as AuthenticatedExamsExamidRouteImport } from './routes/_authenticated/exams/$examid'
import { Route as AuthenticatedFinanceIndexRouteImport } from './routes/_authenticated/finance/index'
import { Route as AuthenticatedFinanceCategoriesRouteImport } from './routes/_authenticated/finance/categories'
import { Route as AuthenticatedFinanceCreateRouteImport } from './routes/_authenticated/finance/create'
import { Route as AuthenticatedFinanceHouseholdRouteImport } from './routes/_authenticated/finance/household'
import { Route as AuthenticatedFinanceProductsRouteImport } from './routes/_authenticated/finance/products'
import { Route as AuthenticatedFinanceReportsRouteImport } from './routes/_authenticated/finance/reports'
import { Route as AuthenticatedFinanceRulesRouteImport } from './routes/_authenticated/finance/rules'
import { Route as AuthenticatedFinanceTransactionsRouteImport } from './routes/_authenticated/finance/transactions'
import { Route as AuthenticatedJournIndexRouteImport } from './routes/_authenticated/journ/index'
import { Route as AuthenticatedJournDayRouteImport } from './routes/_authenticated/journ/$day'
import { Route as AuthenticatedJournCalendarsRouteImport } from './routes/_authenticated/journ/calendars'
import { Route as AuthenticatedPetsIndexRouteImport } from './routes/_authenticated/pets/index'
import { Route as AuthenticatedPetsCreateRouteImport } from './routes/_authenticated/pets/create'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsGeneralRouteImport } from './routes/_authenticated/settings/general'
import { Route as AuthenticatedSettingsProductsRouteImport } from './routes/_authenticated/settings/products'
import { Route as AuthenticatedShoppingIndexRouteImport } from './routes/_authenticated/shopping/index'
import { Route as AuthenticatedShoppingListidRouteImport } from './routes/_authenticated/shopping/$listid'
import { Route as AuthenticatedWorldIndexRouteImport } from './routes/_authenticated/world/index'
import { Route as AuthenticatedPetsPetIdIndexRouteImport } from './routes/_authenticated/pets/$petId/index'
import { Route as AuthenticatedPetsPetIdEditRouteImport } from './routes/_authenticated/pets/$petId/edit'
import { Route as AuthenticatedPetsPetIdHealthRouteImport } from './routes/_authenticated/pets/$petId/health'
import { Route as AuthenticatedPetsPetIdPhotosRouteImport } from './routes/_authenticated/pets/$petId/photos'
import { Route as AuthenticatedPetsPetIdTutorsRouteImport } from './routes/_authenticated/pets/$petId/tutors'
import { Route as AuthenticatedPetsClinicsIndexRouteImport } from './routes/_authenticated/pets/clinics/index'
import { Route as AuthenticatedPetsClinicsCreateRouteImport } from './routes/_authenticated/pets/clinics/create'
import { Route as AuthenticatedPetsVetsIndexRouteImport } from './routes/_authenticated/pets/vets/index'
import { Route as AuthenticatedPetsVetsCreateRouteImport } from './routes/_authenticated/pets/vets/create'
import { Route as AuthenticatedPetsPetIdAllergiesCreateRouteImport } from './routes/_authenticated/pets/$petId/allergies/create'
import { Route as AuthenticatedPetsPetIdConditionsCreateRouteImport } from './routes/_authenticated/pets/$petId/conditions/create'
import { Route as AuthenticatedPetsPetIdExamsCreateRouteImport } from './routes/_authenticated/pets/$petId/exams/create'
import { Route as AuthenticatedPetsPetIdMedicationsCreateRouteImport } from './routes/_authenticated/pets/$petId/medications/create'
import { Route as AuthenticatedPetsPetIdProceduresCreateRouteImport } from './routes/_authenticated/pets/$petId/procedures/create'
import { Route as AuthenticatedPetsPetIdVaccinesIndexRouteImport } from './routes/_authenticated/pets/$petId/vaccines/index'
import { Route as AuthenticatedPetsPetIdVaccinesCreateRouteImport } from './routes/_authenticated/pets/$petId/vaccines/create'
import { Route as AuthenticatedPetsClinicsClinicIdEditRouteImport } from './routes/_authenticated/pets/clinics/$clinicId/edit'
import { Route as AuthenticatedPetsVetsVetIdEditRouteImport } from './routes/_authenticated/pets/vets/$vetId/edit'
import { Route as AuthenticatedPetsPetIdAllergiesAllergyIdEditRouteImport } from './routes/_authenticated/pets/$petId/allergies/$allergyId/edit'
import { Route as AuthenticatedPetsPetIdConditionsConditionIdEditRouteImport } from './routes/_authenticated/pets/$petId/conditions/$conditionId/edit'
import { Route as AuthenticatedPetsPetIdExamsExamIdIndexRouteImport } from './routes/_authenticated/pets/$petId/exams/$examId/index'
import { Route as AuthenticatedPetsPetIdExamsExamIdEditRouteImport } from './routes/_authenticated/pets/$petId/exams/$examId/edit'
import { Route as AuthenticatedPetsPetIdMedicationsMedicationIdEditRouteImport } from './routes/_authenticated/pets/$petId/medications/$medicationId/edit'
import { Route as AuthenticatedPetsPetIdProceduresProcedureIdEditRouteImport } from './routes/_authenticated/pets/$petId/procedures/$procedureId/edit'
import { Route as AuthenticatedPetsPetIdVaccinesVaccineIdEditRouteImport } from './routes/_authenticated/pets/$petId/vaccines/$vaccineId/edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AnimationRoute = AnimationRouteImport.update({
  id: '/animation',
  path: '/animation',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ScanSpikeRoute = ScanSpikeRouteImport.update({
  id: '/scan-spike',
  path: '/scan-spike',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecoveryRoute = AuthRecoveryRouteImport.update({
  id: '/recovery',
  path: '/recovery',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWelcomeRoute = AuthWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedExamsRoute = AuthenticatedExamsRouteImport.update({
  id: '/exams',
  path: '/exams',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFinanceRoute = AuthenticatedFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedJournRoute = AuthenticatedJournRouteImport.update({
  id: '/journ',
  path: '/journ',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMetricsRoute = AuthenticatedMetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPetsRoute = AuthenticatedPetsRouteImport.update({
  id: '/pets',
  path: '/pets',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPomodoroRoute = AuthenticatedPomodoroRouteImport.update({
  id: '/pomodoro',
  path: '/pomodoro',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedShoppingRoute = AuthenticatedShoppingRouteImport.update({
  id: '/shopping',
  path: '/shopping',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWorldRoute = AuthenticatedWorldRouteImport.update({
  id: '/world',
  path: '/world',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedExamsIndexRoute = AuthenticatedExamsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedExamsRoute,
} as any)
const AuthenticatedExamsExamidRoute =
  AuthenticatedExamsExamidRouteImport.update({
    id: '/$examid',
    path: '/$examid',
    getParentRoute: () => AuthenticatedExamsRoute,
  } as any)
const AuthenticatedFinanceIndexRoute =
  AuthenticatedFinanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedFinanceCategoriesRoute =
  AuthenticatedFinanceCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedFinanceCreateRoute =
  AuthenticatedFinanceCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedFinanceHouseholdRoute =
  AuthenticatedFinanceHouseholdRouteImport.update({
    id: '/household',
    path: '/household',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedFinanceProductsRoute =
  AuthenticatedFinanceProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedFinanceReportsRoute =
  AuthenticatedFinanceReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedFinanceRulesRoute =
  AuthenticatedFinanceRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedFinanceTransactionsRoute =
  AuthenticatedFinanceTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AuthenticatedFinanceRoute,
  } as any)
const AuthenticatedJournIndexRoute = AuthenticatedJournIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedJournRoute,
} as any)
const AuthenticatedJournDayRoute = AuthenticatedJournDayRouteImport.update({
  id: '/$day',
  path: '/$day',
  getParentRoute: () => AuthenticatedJournRoute,
} as any)
const AuthenticatedJournCalendarsRoute =
  AuthenticatedJournCalendarsRouteImport.update({
    id: '/calendars',
    path: '/calendars',
    getParentRoute: () => AuthenticatedJournRoute,
  } as any)
const AuthenticatedPetsIndexRoute = AuthenticatedPetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedPetsRoute,
} as any)
const AuthenticatedPetsCreateRoute = AuthenticatedPetsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthenticatedPetsRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsGeneralRoute =
  AuthenticatedSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsProductsRoute =
  AuthenticatedSettingsProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedShoppingIndexRoute =
  AuthenticatedShoppingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedShoppingRoute,
  } as any)
const AuthenticatedShoppingListidRoute =
  AuthenticatedShoppingListidRouteImport.update({
    id: '/$listid',
    path: '/$listid',
    getParentRoute: () => AuthenticatedShoppingRoute,
  } as any)
const AuthenticatedWorldIndexRoute = AuthenticatedWorldIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedWorldRoute,
} as any)
const AuthenticatedPetsPetIdIndexRoute =
  AuthenticatedPetsPetIdIndexRouteImport.update({
    id: '/$petId/',
    path: '/$petId/',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdEditRoute =
  AuthenticatedPetsPetIdEditRouteImport.update({
    id: '/$petId/edit',
    path: '/$petId/edit',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdHealthRoute =
  AuthenticatedPetsPetIdHealthRouteImport.update({
    id: '/$petId/health',
    path: '/$petId/health',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdPhotosRoute =
  AuthenticatedPetsPetIdPhotosRouteImport.update({
    id: '/$petId/photos',
    path: '/$petId/photos',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdTutorsRoute =
  AuthenticatedPetsPetIdTutorsRouteImport.update({
    id: '/$petId/tutors',
    path: '/$petId/tutors',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsClinicsIndexRoute =
  AuthenticatedPetsClinicsIndexRouteImport.update({
    id: '/clinics/',
    path: '/clinics/',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsClinicsCreateRoute =
  AuthenticatedPetsClinicsCreateRouteImport.update({
    id: '/clinics/create',
    path: '/clinics/create',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsVetsIndexRoute =
  AuthenticatedPetsVetsIndexRouteImport.update({
    id: '/vets/',
    path: '/vets/',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsVetsCreateRoute =
  AuthenticatedPetsVetsCreateRouteImport.update({
    id: '/vets/create',
    path: '/vets/create',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdAllergiesCreateRoute =
  AuthenticatedPetsPetIdAllergiesCreateRouteImport.update({
    id: '/$petId/allergies/create',
    path: '/$petId/allergies/create',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdConditionsCreateRoute =
  AuthenticatedPetsPetIdConditionsCreateRouteImport.update({
    id: '/$petId/conditions/create',
    path: '/$petId/conditions/create',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdExamsCreateRoute =
  AuthenticatedPetsPetIdExamsCreateRouteImport.update({
    id: '/$petId/exams/create',
    path: '/$petId/exams/create',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdMedicationsCreateRoute =
  AuthenticatedPetsPetIdMedicationsCreateRouteImport.update({
    id: '/$petId/medications/create',
    path: '/$petId/medications/create',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdProceduresCreateRoute =
  AuthenticatedPetsPetIdProceduresCreateRouteImport.update({
    id: '/$petId/procedures/create',
    path: '/$petId/procedures/create',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdVaccinesIndexRoute =
  AuthenticatedPetsPetIdVaccinesIndexRouteImport.update({
    id: '/$petId/vaccines/',
    path: '/$petId/vaccines/',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdVaccinesCreateRoute =
  AuthenticatedPetsPetIdVaccinesCreateRouteImport.update({
    id: '/$petId/vaccines/create',
    path: '/$petId/vaccines/create',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsClinicsClinicIdEditRoute =
  AuthenticatedPetsClinicsClinicIdEditRouteImport.update({
    id: '/clinics/$clinicId/edit',
    path: '/clinics/$clinicId/edit',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsVetsVetIdEditRoute =
  AuthenticatedPetsVetsVetIdEditRouteImport.update({
    id: '/vets/$vetId/edit',
    path: '/vets/$vetId/edit',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdAllergiesAllergyIdEditRoute =
  AuthenticatedPetsPetIdAllergiesAllergyIdEditRouteImport.update({
    id: '/$petId/allergies/$allergyId/edit',
    path: '/$petId/allergies/$allergyId/edit',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdConditionsConditionIdEditRoute =
  AuthenticatedPetsPetIdConditionsConditionIdEditRouteImport.update({
    id: '/$petId/conditions/$conditionId/edit',
    path: '/$petId/conditions/$conditionId/edit',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdExamsExamIdIndexRoute =
  AuthenticatedPetsPetIdExamsExamIdIndexRouteImport.update({
    id: '/$petId/exams/$examId/',
    path: '/$petId/exams/$examId/',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdExamsExamIdEditRoute =
  AuthenticatedPetsPetIdExamsExamIdEditRouteImport.update({
    id: '/$petId/exams/$examId/edit',
    path: '/$petId/exams/$examId/edit',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdMedicationsMedicationIdEditRoute =
  AuthenticatedPetsPetIdMedicationsMedicationIdEditRouteImport.update({
    id: '/$petId/medications/$medicationId/edit',
    path: '/$petId/medications/$medicationId/edit',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdProceduresProcedureIdEditRoute =
  AuthenticatedPetsPetIdProceduresProcedureIdEditRouteImport.update({
    id: '/$petId/procedures/$procedureId/edit',
    path: '/$petId/procedures/$procedureId/edit',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)
const AuthenticatedPetsPetIdVaccinesVaccineIdEditRoute =
  AuthenticatedPetsPetIdVaccinesVaccineIdEditRouteImport.update({
    id: '/$petId/vaccines/$vaccineId/edit',
    path: '/$petId/vaccines/$vaccineId/edit',
    getParentRoute: () => AuthenticatedPetsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/animation': typeof AnimationRoute
  '/legal': typeof LegalRoute
  '/privacy': typeof PrivacyRoute
  '/scan-spike': typeof ScanSpikeRoute
  '/login': typeof AuthLoginRoute
  '/recovery': typeof AuthRecoveryRoute
  '/welcome': typeof AuthWelcomeRoute
  '/exams': typeof AuthenticatedExamsRouteWithChildren
  '/finance': typeof AuthenticatedFinanceRouteWithChildren
  '/journ': typeof AuthenticatedJournRouteWithChildren
  '/metrics': typeof AuthenticatedMetricsRoute
  '/pets': typeof AuthenticatedPetsRouteWithChildren
  '/pomodoro': typeof AuthenticatedPomodoroRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/shopping': typeof AuthenticatedShoppingRouteWithChildren
  '/world': typeof AuthenticatedWorldRouteWithChildren
  '/share/$token': typeof ShareTokenRoute
  '/exams/$examid': typeof AuthenticatedExamsExamidRoute
  '/finance/categories': typeof AuthenticatedFinanceCategoriesRoute
  '/finance/create': typeof AuthenticatedFinanceCreateRoute
  '/finance/household': typeof AuthenticatedFinanceHouseholdRoute
  '/finance/products': typeof AuthenticatedFinanceProductsRoute
  '/finance/reports': typeof AuthenticatedFinanceReportsRoute
  '/finance/rules': typeof AuthenticatedFinanceRulesRoute
  '/finance/transactions': typeof AuthenticatedFinanceTransactionsRoute
  '/journ/$day': typeof AuthenticatedJournDayRoute
  '/journ/calendars': typeof AuthenticatedJournCalendarsRoute
  '/pets/create': typeof AuthenticatedPetsCreateRoute
  '/settings/general': typeof AuthenticatedSettingsGeneralRoute
  '/settings/products': typeof AuthenticatedSettingsProductsRoute
  '/shopping/$listid': typeof AuthenticatedShoppingListidRoute
  '/exams/': typeof AuthenticatedExamsIndexRoute
  '/finance/': typeof AuthenticatedFinanceIndexRoute
  '/journ/': typeof AuthenticatedJournIndexRoute
  '/pets/': typeof AuthenticatedPetsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/shopping/': typeof AuthenticatedShoppingIndexRoute
  '/world/': typeof AuthenticatedWorldIndexRoute
  '/pets/$petId/edit': typeof AuthenticatedPetsPetIdEditRoute
  '/pets/$petId/health': typeof AuthenticatedPetsPetIdHealthRoute
  '/pets/$petId/photos': typeof AuthenticatedPetsPetIdPhotosRoute
  '/pets/$petId/tutors': typeof AuthenticatedPetsPetIdTutorsRoute
  '/pets/clinics/create': typeof AuthenticatedPetsClinicsCreateRoute
  '/pets/vets/create': typeof AuthenticatedPetsVetsCreateRoute
  '/pets/$petId/': typeof AuthenticatedPetsPetIdIndexRoute
  '/pets/clinics/': typeof AuthenticatedPetsClinicsIndexRoute
  '/pets/vets/': typeof AuthenticatedPetsVetsIndexRoute
  '/pets/$petId/allergies/create': typeof AuthenticatedPetsPetIdAllergiesCreateRoute
  '/pets/$petId/conditions/create': typeof AuthenticatedPetsPetIdConditionsCreateRoute
  '/pets/$petId/exams/create': typeof AuthenticatedPetsPetIdExamsCreateRoute
  '/pets/$petId/medications/create': typeof AuthenticatedPetsPetIdMedicationsCreateRoute
  '/pets/$petId/procedures/create': typeof AuthenticatedPetsPetIdProceduresCreateRoute
  '/pets/$petId/vaccines/create': typeof AuthenticatedPetsPetIdVaccinesCreateRoute
  '/pets/clinics/$clinicId/edit': typeof AuthenticatedPetsClinicsClinicIdEditRoute
  '/pets/vets/$vetId/edit': typeof AuthenticatedPetsVetsVetIdEditRoute
  '/pets/$petId/vaccines/': typeof AuthenticatedPetsPetIdVaccinesIndexRoute
  '/pets/$petId/allergies/$allergyId/edit': typeof AuthenticatedPetsPetIdAllergiesAllergyIdEditRoute
  '/pets/$petId/conditions/$conditionId/edit': typeof AuthenticatedPetsPetIdConditionsConditionIdEditRoute
  '/pets/$petId/exams/$examId/edit': typeof AuthenticatedPetsPetIdExamsExamIdEditRoute
  '/pets/$petId/medications/$medicationId/edit': typeof AuthenticatedPetsPetIdMedicationsMedicationIdEditRoute
  '/pets/$petId/procedures/$procedureId/edit': typeof AuthenticatedPetsPetIdProceduresProcedureIdEditRoute
  '/pets/$petId/vaccines/$vaccineId/edit': typeof AuthenticatedPetsPetIdVaccinesVaccineIdEditRoute
  '/pets/$petId/exams/$examId/': typeof AuthenticatedPetsPetIdExamsExamIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/animation': typeof AnimationRoute
  '/legal': typeof LegalRoute
  '/privacy': typeof PrivacyRoute
  '/scan-spike': typeof ScanSpikeRoute
  '/login': typeof AuthLoginRoute
  '/recovery': typeof AuthRecoveryRoute
  '/welcome': typeof AuthWelcomeRoute
  '/metrics': typeof AuthenticatedMetricsRoute
  '/pomodoro': typeof AuthenticatedPomodoroRoute
  '/share/$token': typeof ShareTokenRoute
  '/exams/$examid': typeof AuthenticatedExamsExamidRoute
  '/finance/categories': typeof AuthenticatedFinanceCategoriesRoute
  '/finance/create': typeof AuthenticatedFinanceCreateRoute
  '/finance/household': typeof AuthenticatedFinanceHouseholdRoute
  '/finance/products': typeof AuthenticatedFinanceProductsRoute
  '/finance/reports': typeof AuthenticatedFinanceReportsRoute
  '/finance/rules': typeof AuthenticatedFinanceRulesRoute
  '/finance/transactions': typeof AuthenticatedFinanceTransactionsRoute
  '/journ/$day': typeof AuthenticatedJournDayRoute
  '/journ/calendars': typeof AuthenticatedJournCalendarsRoute
  '/pets/create': typeof AuthenticatedPetsCreateRoute
  '/settings/general': typeof AuthenticatedSettingsGeneralRoute
  '/settings/products': typeof AuthenticatedSettingsProductsRoute
  '/shopping/$listid': typeof AuthenticatedShoppingListidRoute
  '/exams': typeof AuthenticatedExamsIndexRoute
  '/finance': typeof AuthenticatedFinanceIndexRoute
  '/journ': typeof AuthenticatedJournIndexRoute
  '/pets': typeof AuthenticatedPetsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/shopping': typeof AuthenticatedShoppingIndexRoute
  '/world': typeof AuthenticatedWorldIndexRoute
  '/pets/$petId/edit': typeof AuthenticatedPetsPetIdEditRoute
  '/pets/$petId/health': typeof AuthenticatedPetsPetIdHealthRoute
  '/pets/$petId/photos': typeof AuthenticatedPetsPetIdPhotosRoute
  '/pets/$petId/tutors': typeof AuthenticatedPetsPetIdTutorsRoute
  '/pets/clinics/create': typeof AuthenticatedPetsClinicsCreateRoute
  '/pets/vets/create': typeof AuthenticatedPetsVetsCreateRoute
  '/pets/$petId': typeof AuthenticatedPetsPetIdIndexRoute
  '/pets/clinics': typeof AuthenticatedPetsClinicsIndexRoute
  '/pets/vets': typeof AuthenticatedPetsVetsIndexRoute
  '/pets/$petId/allergies/create': typeof AuthenticatedPetsPetIdAllergiesCreateRoute
  '/pets/$petId/conditions/create': typeof AuthenticatedPetsPetIdConditionsCreateRoute
  '/pets/$petId/exams/create': typeof AuthenticatedPetsPetIdExamsCreateRoute
  '/pets/$petId/medications/create': typeof AuthenticatedPetsPetIdMedicationsCreateRoute
  '/pets/$petId/procedures/create': typeof AuthenticatedPetsPetIdProceduresCreateRoute
  '/pets/$petId/vaccines/create': typeof AuthenticatedPetsPetIdVaccinesCreateRoute
  '/pets/clinics/$clinicId/edit': typeof AuthenticatedPetsClinicsClinicIdEditRoute
  '/pets/vets/$vetId/edit': typeof AuthenticatedPetsVetsVetIdEditRoute
  '/pets/$petId/vaccines': typeof AuthenticatedPetsPetIdVaccinesIndexRoute
  '/pets/$petId/allergies/$allergyId/edit': typeof AuthenticatedPetsPetIdAllergiesAllergyIdEditRoute
  '/pets/$petId/conditions/$conditionId/edit': typeof AuthenticatedPetsPetIdConditionsConditionIdEditRoute
  '/pets/$petId/exams/$examId/edit': typeof AuthenticatedPetsPetIdExamsExamIdEditRoute
  '/pets/$petId/medications/$medicationId/edit': typeof AuthenticatedPetsPetIdMedicationsMedicationIdEditRoute
  '/pets/$petId/procedures/$procedureId/edit': typeof AuthenticatedPetsPetIdProceduresProcedureIdEditRoute
  '/pets/$petId/vaccines/$vaccineId/edit': typeof AuthenticatedPetsPetIdVaccinesVaccineIdEditRoute
  '/pets/$petId/exams/$examId': typeof AuthenticatedPetsPetIdExamsExamIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/animation': typeof AnimationRoute
  '/legal': typeof LegalRoute
  '/privacy': typeof PrivacyRoute
  '/scan-spike': typeof ScanSpikeRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/recovery': typeof AuthRecoveryRoute
  '/_auth/welcome': typeof AuthWelcomeRoute
  '/_authenticated/exams': typeof AuthenticatedExamsRouteWithChildren
  '/_authenticated/finance': typeof AuthenticatedFinanceRouteWithChildren
  '/_authenticated/journ': typeof AuthenticatedJournRouteWithChildren
  '/_authenticated/metrics': typeof AuthenticatedMetricsRoute
  '/_authenticated/pets': typeof AuthenticatedPetsRouteWithChildren
  '/_authenticated/pomodoro': typeof AuthenticatedPomodoroRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/shopping': typeof AuthenticatedShoppingRouteWithChildren
  '/_authenticated/world': typeof AuthenticatedWorldRouteWithChildren
  '/share/$token': typeof ShareTokenRoute
  '/_authenticated/exams/$examid': typeof AuthenticatedExamsExamidRoute
  '/_authenticated/finance/categories': typeof AuthenticatedFinanceCategoriesRoute
  '/_authenticated/finance/create': typeof AuthenticatedFinanceCreateRoute
  '/_authenticated/finance/household': typeof AuthenticatedFinanceHouseholdRoute
  '/_authenticated/finance/products': typeof AuthenticatedFinanceProductsRoute
  '/_authenticated/finance/reports': typeof AuthenticatedFinanceReportsRoute
  '/_authenticated/finance/rules': typeof AuthenticatedFinanceRulesRoute
  '/_authenticated/finance/transactions': typeof AuthenticatedFinanceTransactionsRoute
  '/_authenticated/journ/$day': typeof AuthenticatedJournDayRoute
  '/_authenticated/journ/calendars': typeof AuthenticatedJournCalendarsRoute
  '/_authenticated/pets/create': typeof AuthenticatedPetsCreateRoute
  '/_authenticated/settings/general': typeof AuthenticatedSettingsGeneralRoute
  '/_authenticated/settings/products': typeof AuthenticatedSettingsProductsRoute
  '/_authenticated/shopping/$listid': typeof AuthenticatedShoppingListidRoute
  '/_authenticated/exams/': typeof AuthenticatedExamsIndexRoute
  '/_authenticated/finance/': typeof AuthenticatedFinanceIndexRoute
  '/_authenticated/journ/': typeof AuthenticatedJournIndexRoute
  '/_authenticated/pets/': typeof AuthenticatedPetsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/shopping/': typeof AuthenticatedShoppingIndexRoute
  '/_authenticated/world/': typeof AuthenticatedWorldIndexRoute
  '/_authenticated/pets/$petId/edit': typeof AuthenticatedPetsPetIdEditRoute
  '/_authenticated/pets/$petId/health': typeof AuthenticatedPetsPetIdHealthRoute
  '/_authenticated/pets/$petId/photos': typeof AuthenticatedPetsPetIdPhotosRoute
  '/_authenticated/pets/$petId/tutors': typeof AuthenticatedPetsPetIdTutorsRoute
  '/_authenticated/pets/clinics/create': typeof AuthenticatedPetsClinicsCreateRoute
  '/_authenticated/pets/vets/create': typeof AuthenticatedPetsVetsCreateRoute
  '/_authenticated/pets/$petId/': typeof AuthenticatedPetsPetIdIndexRoute
  '/_authenticated/pets/clinics/': typeof AuthenticatedPetsClinicsIndexRoute
  '/_authenticated/pets/vets/': typeof AuthenticatedPetsVetsIndexRoute
  '/_authenticated/pets/$petId/allergies/create': typeof AuthenticatedPetsPetIdAllergiesCreateRoute
  '/_authenticated/pets/$petId/conditions/create': typeof AuthenticatedPetsPetIdConditionsCreateRoute
  '/_authenticated/pets/$petId/exams/create': typeof AuthenticatedPetsPetIdExamsCreateRoute
  '/_authenticated/pets/$petId/medications/create': typeof AuthenticatedPetsPetIdMedicationsCreateRoute
  '/_authenticated/pets/$petId/procedures/create': typeof AuthenticatedPetsPetIdProceduresCreateRoute
  '/_authenticated/pets/$petId/vaccines/create': typeof AuthenticatedPetsPetIdVaccinesCreateRoute
  '/_authenticated/pets/clinics/$clinicId/edit': typeof AuthenticatedPetsClinicsClinicIdEditRoute
  '/_authenticated/pets/vets/$vetId/edit': typeof AuthenticatedPetsVetsVetIdEditRoute
  '/_authenticated/pets/$petId/vaccines/': typeof AuthenticatedPetsPetIdVaccinesIndexRoute
  '/_authenticated/pets/$petId/allergies/$allergyId/edit': typeof AuthenticatedPetsPetIdAllergiesAllergyIdEditRoute
  '/_authenticated/pets/$petId/conditions/$conditionId/edit': typeof AuthenticatedPetsPetIdConditionsConditionIdEditRoute
  '/_authenticated/pets/$petId/exams/$examId/edit': typeof AuthenticatedPetsPetIdExamsExamIdEditRoute
  '/_authenticated/pets/$petId/medications/$medicationId/edit': typeof AuthenticatedPetsPetIdMedicationsMedicationIdEditRoute
  '/_authenticated/pets/$petId/procedures/$procedureId/edit': typeof AuthenticatedPetsPetIdProceduresProcedureIdEditRoute
  '/_authenticated/pets/$petId/vaccines/$vaccineId/edit': typeof AuthenticatedPetsPetIdVaccinesVaccineIdEditRoute
  '/_authenticated/pets/$petId/exams/$examId/': typeof AuthenticatedPetsPetIdExamsExamIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/animation'
    | '/legal'
    | '/privacy'
    | '/scan-spike'
    | '/login'
    | '/recovery'
    | '/welcome'
    | '/exams'
    | '/finance'
    | '/journ'
    | '/metrics'
    | '/pets'
    | '/pomodoro'
    | '/settings'
    | '/shopping'
    | '/world'
    | '/share/$token'
    | '/exams/$examid'
    | '/finance/categories'
    | '/finance/create'
    | '/finance/household'
    | '/finance/products'
    | '/finance/reports'
    | '/finance/rules'
    | '/finance/transactions'
    | '/journ/$day'
    | '/journ/calendars'
    | '/pets/create'
    | '/settings/general'
    | '/settings/products'
    | '/shopping/$listid'
    | '/exams/'
    | '/finance/'
    | '/journ/'
    | '/pets/'
    | '/settings/'
    | '/shopping/'
    | '/world/'
    | '/pets/$petId/edit'
    | '/pets/$petId/health'
    | '/pets/$petId/photos'
    | '/pets/$petId/tutors'
    | '/pets/clinics/create'
    | '/pets/vets/create'
    | '/pets/$petId/'
    | '/pets/clinics/'
    | '/pets/vets/'
    | '/pets/$petId/allergies/create'
    | '/pets/$petId/conditions/create'
    | '/pets/$petId/exams/create'
    | '/pets/$petId/medications/create'
    | '/pets/$petId/procedures/create'
    | '/pets/$petId/vaccines/create'
    | '/pets/clinics/$clinicId/edit'
    | '/pets/vets/$vetId/edit'
    | '/pets/$petId/vaccines/'
    | '/pets/$petId/allergies/$allergyId/edit'
    | '/pets/$petId/conditions/$conditionId/edit'
    | '/pets/$petId/exams/$examId/edit'
    | '/pets/$petId/medications/$medicationId/edit'
    | '/pets/$petId/procedures/$procedureId/edit'
    | '/pets/$petId/vaccines/$vaccineId/edit'
    | '/pets/$petId/exams/$examId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/animation'
    | '/legal'
    | '/privacy'
    | '/scan-spike'
    | '/login'
    | '/recovery'
    | '/welcome'
    | '/metrics'
    | '/pomodoro'
    | '/share/$token'
    | '/exams/$examid'
    | '/finance/categories'
    | '/finance/create'
    | '/finance/household'
    | '/finance/products'
    | '/finance/reports'
    | '/finance/rules'
    | '/finance/transactions'
    | '/journ/$day'
    | '/journ/calendars'
    | '/pets/create'
    | '/settings/general'
    | '/settings/products'
    | '/shopping/$listid'
    | '/exams'
    | '/finance'
    | '/journ'
    | '/pets'
    | '/settings'
    | '/shopping'
    | '/world'
    | '/pets/$petId/edit'
    | '/pets/$petId/health'
    | '/pets/$petId/photos'
    | '/pets/$petId/tutors'
    | '/pets/clinics/create'
    | '/pets/vets/create'
    | '/pets/$petId'
    | '/pets/clinics'
    | '/pets/vets'
    | '/pets/$petId/allergies/create'
    | '/pets/$petId/conditions/create'
    | '/pets/$petId/exams/create'
    | '/pets/$petId/medications/create'
    | '/pets/$petId/procedures/create'
    | '/pets/$petId/vaccines/create'
    | '/pets/clinics/$clinicId/edit'
    | '/pets/vets/$vetId/edit'
    | '/pets/$petId/vaccines'
    | '/pets/$petId/allergies/$allergyId/edit'
    | '/pets/$petId/conditions/$conditionId/edit'
    | '/pets/$petId/exams/$examId/edit'
    | '/pets/$petId/medications/$medicationId/edit'
    | '/pets/$petId/procedures/$procedureId/edit'
    | '/pets/$petId/vaccines/$vaccineId/edit'
    | '/pets/$petId/exams/$examId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_authenticated'
    | '/animation'
    | '/legal'
    | '/privacy'
    | '/scan-spike'
    | '/_auth/login'
    | '/_auth/recovery'
    | '/_auth/welcome'
    | '/_authenticated/exams'
    | '/_authenticated/finance'
    | '/_authenticated/journ'
    | '/_authenticated/metrics'
    | '/_authenticated/pets'
    | '/_authenticated/pomodoro'
    | '/_authenticated/settings'
    | '/_authenticated/shopping'
    | '/_authenticated/world'
    | '/share/$token'
    | '/_authenticated/exams/$examid'
    | '/_authenticated/finance/categories'
    | '/_authenticated/finance/create'
    | '/_authenticated/finance/household'
    | '/_authenticated/finance/products'
    | '/_authenticated/finance/reports'
    | '/_authenticated/finance/rules'
    | '/_authenticated/finance/transactions'
    | '/_authenticated/journ/$day'
    | '/_authenticated/journ/calendars'
    | '/_authenticated/pets/create'
    | '/_authenticated/settings/general'
    | '/_authenticated/settings/products'
    | '/_authenticated/shopping/$listid'
    | '/_authenticated/exams/'
    | '/_authenticated/finance/'
    | '/_authenticated/journ/'
    | '/_authenticated/pets/'
    | '/_authenticated/settings/'
    | '/_authenticated/shopping/'
    | '/_authenticated/world/'
    | '/_authenticated/pets/$petId/edit'
    | '/_authenticated/pets/$petId/health'
    | '/_authenticated/pets/$petId/photos'
    | '/_authenticated/pets/$petId/tutors'
    | '/_authenticated/pets/clinics/create'
    | '/_authenticated/pets/vets/create'
    | '/_authenticated/pets/$petId/'
    | '/_authenticated/pets/clinics/'
    | '/_authenticated/pets/vets/'
    | '/_authenticated/pets/$petId/allergies/create'
    | '/_authenticated/pets/$petId/conditions/create'
    | '/_authenticated/pets/$petId/exams/create'
    | '/_authenticated/pets/$petId/medications/create'
    | '/_authenticated/pets/$petId/procedures/create'
    | '/_authenticated/pets/$petId/vaccines/create'
    | '/_authenticated/pets/clinics/$clinicId/edit'
    | '/_authenticated/pets/vets/$vetId/edit'
    | '/_authenticated/pets/$petId/vaccines/'
    | '/_authenticated/pets/$petId/allergies/$allergyId/edit'
    | '/_authenticated/pets/$petId/conditions/$conditionId/edit'
    | '/_authenticated/pets/$petId/exams/$examId/edit'
    | '/_authenticated/pets/$petId/medications/$medicationId/edit'
    | '/_authenticated/pets/$petId/procedures/$procedureId/edit'
    | '/_authenticated/pets/$petId/vaccines/$vaccineId/edit'
    | '/_authenticated/pets/$petId/exams/$examId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AnimationRoute: typeof AnimationRoute
  LegalRoute: typeof LegalRoute
  PrivacyRoute: typeof PrivacyRoute
  ScanSpikeRoute: typeof ScanSpikeRoute
  ShareTokenRoute: typeof ShareTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/animation': {
      id: '/animation'
      path: '/animation'
      fullPath: '/animation'
      preLoaderRoute: typeof AnimationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scan-spike': {
      id: '/scan-spike'
      path: '/scan-spike'
      fullPath: '/scan-spike'
      preLoaderRoute: typeof ScanSpikeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recovery': {
      id: '/_auth/recovery'
      path: '/recovery'
      fullPath: '/recovery'
      preLoaderRoute: typeof AuthRecoveryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/welcome': {
      id: '/_auth/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof AuthWelcomeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/exams': {
      id: '/_authenticated/exams'
      path: '/exams'
      fullPath: '/exams'
      preLoaderRoute: typeof AuthenticatedExamsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/finance': {
      id: '/_authenticated/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof AuthenticatedFinanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/journ': {
      id: '/_authenticated/journ'
      path: '/journ'
      fullPath: '/journ'
      preLoaderRoute: typeof AuthenticatedJournRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/metrics': {
      id: '/_authenticated/metrics'
      path: '/metrics'
      fullPath: '/metrics'
      preLoaderRoute: typeof AuthenticatedMetricsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pets': {
      id: '/_authenticated/pets'
      path: '/pets'
      fullPath: '/pets'
      preLoaderRoute: typeof AuthenticatedPetsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pomodoro': {
      id: '/_authenticated/pomodoro'
      path: '/pomodoro'
      fullPath: '/pomodoro'
      preLoaderRoute: typeof AuthenticatedPomodoroRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/shopping': {
      id: '/_authenticated/shopping'
      path: '/shopping'
      fullPath: '/shopping'
      preLoaderRoute: typeof AuthenticatedShoppingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/world': {
      id: '/_authenticated/world'
      path: '/world'
      fullPath: '/world'
      preLoaderRoute: typeof AuthenticatedWorldRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/exams/': {
      id: '/_authenticated/exams/'
      path: '/'
      fullPath: '/exams/'
      preLoaderRoute: typeof AuthenticatedExamsIndexRouteImport
      parentRoute: typeof AuthenticatedExamsRoute
    }
    '/_authenticated/exams/$examid': {
      id: '/_authenticated/exams/$examid'
      path: '/$examid'
      fullPath: '/exams/$examid'
      preLoaderRoute: typeof AuthenticatedExamsExamidRouteImport
      parentRoute: typeof AuthenticatedExamsRoute
    }
    '/_authenticated/finance/': {
      id: '/_authenticated/finance/'
      path: '/'
      fullPath: '/finance/'
      preLoaderRoute: typeof AuthenticatedFinanceIndexRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/finance/categories': {
      id: '/_authenticated/finance/categories'
      path: '/categories'
      fullPath: '/finance/categories'
      preLoaderRoute: typeof AuthenticatedFinanceCategoriesRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/finance/create': {
      id: '/_authenticated/finance/create'
      path: '/create'
      fullPath: '/finance/create'
      preLoaderRoute: typeof AuthenticatedFinanceCreateRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/finance/household': {
      id: '/_authenticated/finance/household'
      path: '/household'
      fullPath: '/finance/household'
      preLoaderRoute: typeof AuthenticatedFinanceHouseholdRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/finance/products': {
      id: '/_authenticated/finance/products'
      path: '/products'
      fullPath: '/finance/products'
      preLoaderRoute: typeof AuthenticatedFinanceProductsRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/finance/reports': {
      id: '/_authenticated/finance/reports'
      path: '/reports'
      fullPath: '/finance/reports'
      preLoaderRoute: typeof AuthenticatedFinanceReportsRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/finance/rules': {
      id: '/_authenticated/finance/rules'
      path: '/rules'
      fullPath: '/finance/rules'
      preLoaderRoute: typeof AuthenticatedFinanceRulesRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/finance/transactions': {
      id: '/_authenticated/finance/transactions'
      path: '/transactions'
      fullPath: '/finance/transactions'
      preLoaderRoute: typeof AuthenticatedFinanceTransactionsRouteImport
      parentRoute: typeof AuthenticatedFinanceRoute
    }
    '/_authenticated/journ/': {
      id: '/_authenticated/journ/'
      path: '/'
      fullPath: '/journ/'
      preLoaderRoute: typeof AuthenticatedJournIndexRouteImport
      parentRoute: typeof AuthenticatedJournRoute
    }
    '/_authenticated/journ/$day': {
      id: '/_authenticated/journ/$day'
      path: '/$day'
      fullPath: '/journ/$day'
      preLoaderRoute: typeof AuthenticatedJournDayRouteImport
      parentRoute: typeof AuthenticatedJournRoute
    }
    '/_authenticated/journ/calendars': {
      id: '/_authenticated/journ/calendars'
      path: '/calendars'
      fullPath: '/journ/calendars'
      preLoaderRoute: typeof AuthenticatedJournCalendarsRouteImport
      parentRoute: typeof AuthenticatedJournRoute
    }
    '/_authenticated/pets/': {
      id: '/_authenticated/pets/'
      path: '/'
      fullPath: '/pets/'
      preLoaderRoute: typeof AuthenticatedPetsIndexRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/create': {
      id: '/_authenticated/pets/create'
      path: '/create'
      fullPath: '/pets/create'
      preLoaderRoute: typeof AuthenticatedPetsCreateRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/general': {
      id: '/_authenticated/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof AuthenticatedSettingsGeneralRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/products': {
      id: '/_authenticated/settings/products'
      path: '/products'
      fullPath: '/settings/products'
      preLoaderRoute: typeof AuthenticatedSettingsProductsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/shopping/': {
      id: '/_authenticated/shopping/'
      path: '/'
      fullPath: '/shopping/'
      preLoaderRoute: typeof AuthenticatedShoppingIndexRouteImport
      parentRoute: typeof AuthenticatedShoppingRoute
    }
    '/_authenticated/shopping/$listid': {
      id: '/_authenticated/shopping/$listid'
      path: '/$listid'
      fullPath: '/shopping/$listid'
      preLoaderRoute: typeof AuthenticatedShoppingListidRouteImport
      parentRoute: typeof AuthenticatedShoppingRoute
    }
    '/_authenticated/world/': {
      id: '/_authenticated/world/'
      path: '/'
      fullPath: '/world/'
      preLoaderRoute: typeof AuthenticatedWorldIndexRouteImport
      parentRoute: typeof AuthenticatedWorldRoute
    }
    '/_authenticated/pets/$petId/': {
      id: '/_authenticated/pets/$petId/'
      path: '/$petId'
      fullPath: '/pets/$petId/'
      preLoaderRoute: typeof AuthenticatedPetsPetIdIndexRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/edit': {
      id: '/_authenticated/pets/$petId/edit'
      path: '/$petId/edit'
      fullPath: '/pets/$petId/edit'
      preLoaderRoute: typeof AuthenticatedPetsPetIdEditRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/health': {
      id: '/_authenticated/pets/$petId/health'
      path: '/$petId/health'
      fullPath: '/pets/$petId/health'
      preLoaderRoute: typeof AuthenticatedPetsPetIdHealthRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/photos': {
      id: '/_authenticated/pets/$petId/photos'
      path: '/$petId/photos'
      fullPath: '/pets/$petId/photos'
      preLoaderRoute: typeof AuthenticatedPetsPetIdPhotosRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/tutors': {
      id: '/_authenticated/pets/$petId/tutors'
      path: '/$petId/tutors'
      fullPath: '/pets/$petId/tutors'
      preLoaderRoute: typeof AuthenticatedPetsPetIdTutorsRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/clinics/': {
      id: '/_authenticated/pets/clinics/'
      path: '/clinics'
      fullPath: '/pets/clinics/'
      preLoaderRoute: typeof AuthenticatedPetsClinicsIndexRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/clinics/create': {
      id: '/_authenticated/pets/clinics/create'
      path: '/clinics/create'
      fullPath: '/pets/clinics/create'
      preLoaderRoute: typeof AuthenticatedPetsClinicsCreateRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/vets/': {
      id: '/_authenticated/pets/vets/'
      path: '/vets'
      fullPath: '/pets/vets/'
      preLoaderRoute: typeof AuthenticatedPetsVetsIndexRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/vets/create': {
      id: '/_authenticated/pets/vets/create'
      path: '/vets/create'
      fullPath: '/pets/vets/create'
      preLoaderRoute: typeof AuthenticatedPetsVetsCreateRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/allergies/create': {
      id: '/_authenticated/pets/$petId/allergies/create'
      path: '/$petId/allergies/create'
      fullPath: '/pets/$petId/allergies/create'
      preLoaderRoute: typeof AuthenticatedPetsPetIdAllergiesCreateRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/conditions/create': {
      id: '/_authenticated/pets/$petId/conditions/create'
      path: '/$petId/conditions/create'
      fullPath: '/pets/$petId/conditions/create'
      preLoaderRoute: typeof AuthenticatedPetsPetIdConditionsCreateRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/exams/create': {
      id: '/_authenticated/pets/$petId/exams/create'
      path: '/$petId/exams/create'
      fullPath: '/pets/$petId/exams/create'
      preLoaderRoute: typeof AuthenticatedPetsPetIdExamsCreateRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/medications/create': {
      id: '/_authenticated/pets/$petId/medications/create'
      path: '/$petId/medications/create'
      fullPath: '/pets/$petId/medications/create'
      preLoaderRoute: typeof AuthenticatedPetsPetIdMedicationsCreateRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/procedures/create': {
      id: '/_authenticated/pets/$petId/procedures/create'
      path: '/$petId/procedures/create'
      fullPath: '/pets/$petId/procedures/create'
      preLoaderRoute: typeof AuthenticatedPetsPetIdProceduresCreateRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/vaccines/': {
      id: '/_authenticated/pets/$petId/vaccines/'
      path: '/$petId/vaccines'
      fullPath: '/pets/$petId/vaccines/'
      preLoaderRoute: typeof AuthenticatedPetsPetIdVaccinesIndexRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/vaccines/create': {
      id: '/_authenticated/pets/$petId/vaccines/create'
      path: '/$petId/vaccines/create'
      fullPath: '/pets/$petId/vaccines/create'
      preLoaderRoute: typeof AuthenticatedPetsPetIdVaccinesCreateRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/clinics/$clinicId/edit': {
      id: '/_authenticated/pets/clinics/$clinicId/edit'
      path: '/clinics/$clinicId/edit'
      fullPath: '/pets/clinics/$clinicId/edit'
      preLoaderRoute: typeof AuthenticatedPetsClinicsClinicIdEditRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/vets/$vetId/edit': {
      id: '/_authenticated/pets/vets/$vetId/edit'
      path: '/vets/$vetId/edit'
      fullPath: '/pets/vets/$vetId/edit'
      preLoaderRoute: typeof AuthenticatedPetsVetsVetIdEditRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/allergies/$allergyId/edit': {
      id: '/_authenticated/pets/$petId/allergies/$allergyId/edit'
      path: '/$petId/allergies/$allergyId/edit'
      fullPath: '/pets/$petId/allergies/$allergyId/edit'
      preLoaderRoute: typeof AuthenticatedPetsPetIdAllergiesAllergyIdEditRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/conditions/$conditionId/edit': {
      id: '/_authenticated/pets/$petId/conditions/$conditionId/edit'
      path: '/$petId/conditions/$conditionId/edit'
      fullPath: '/pets/$petId/conditions/$conditionId/edit'
      preLoaderRoute: typeof AuthenticatedPetsPetIdConditionsConditionIdEditRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/exams/$examId/': {
      id: '/_authenticated/pets/$petId/exams/$examId/'
      path: '/$petId/exams/$examId'
      fullPath: '/pets/$petId/exams/$examId/'
      preLoaderRoute: typeof AuthenticatedPetsPetIdExamsExamIdIndexRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/exams/$examId/edit': {
      id: '/_authenticated/pets/$petId/exams/$examId/edit'
      path: '/$petId/exams/$examId/edit'
      fullPath: '/pets/$petId/exams/$examId/edit'
      preLoaderRoute: typeof AuthenticatedPetsPetIdExamsExamIdEditRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/medications/$medicationId/edit': {
      id: '/_authenticated/pets/$petId/medications/$medicationId/edit'
      path: '/$petId/medications/$medicationId/edit'
      fullPath: '/pets/$petId/medications/$medicationId/edit'
      preLoaderRoute: typeof AuthenticatedPetsPetIdMedicationsMedicationIdEditRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/procedures/$procedureId/edit': {
      id: '/_authenticated/pets/$petId/procedures/$procedureId/edit'
      path: '/$petId/procedures/$procedureId/edit'
      fullPath: '/pets/$petId/procedures/$procedureId/edit'
      preLoaderRoute: typeof AuthenticatedPetsPetIdProceduresProcedureIdEditRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
    '/_authenticated/pets/$petId/vaccines/$vaccineId/edit': {
      id: '/_authenticated/pets/$petId/vaccines/$vaccineId/edit'
      path: '/$petId/vaccines/$vaccineId/edit'
      fullPath: '/pets/$petId/vaccines/$vaccineId/edit'
      preLoaderRoute: typeof AuthenticatedPetsPetIdVaccinesVaccineIdEditRouteImport
      parentRoute: typeof AuthenticatedPetsRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRecoveryRoute: typeof AuthRecoveryRoute
  AuthWelcomeRoute: typeof AuthWelcomeRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthRecoveryRoute: AuthRecoveryRoute,
  AuthWelcomeRoute: AuthWelcomeRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedExamsRouteChildren {
  AuthenticatedExamsExamidRoute: typeof AuthenticatedExamsExamidRoute
  AuthenticatedExamsIndexRoute: typeof AuthenticatedExamsIndexRoute
}

const AuthenticatedExamsRouteChildren: AuthenticatedExamsRouteChildren = {
  AuthenticatedExamsExamidRoute: AuthenticatedExamsExamidRoute,
  AuthenticatedExamsIndexRoute: AuthenticatedExamsIndexRoute,
}

const AuthenticatedExamsRouteWithChildren =
  AuthenticatedExamsRoute._addFileChildren(AuthenticatedExamsRouteChildren)

interface AuthenticatedFinanceRouteChildren {
  AuthenticatedFinanceCategoriesRoute: typeof AuthenticatedFinanceCategoriesRoute
  AuthenticatedFinanceCreateRoute: typeof AuthenticatedFinanceCreateRoute
  AuthenticatedFinanceHouseholdRoute: typeof AuthenticatedFinanceHouseholdRoute
  AuthenticatedFinanceProductsRoute: typeof AuthenticatedFinanceProductsRoute
  AuthenticatedFinanceReportsRoute: typeof AuthenticatedFinanceReportsRoute
  AuthenticatedFinanceRulesRoute: typeof AuthenticatedFinanceRulesRoute
  AuthenticatedFinanceTransactionsRoute: typeof AuthenticatedFinanceTransactionsRoute
  AuthenticatedFinanceIndexRoute: typeof AuthenticatedFinanceIndexRoute
}

const AuthenticatedFinanceRouteChildren: AuthenticatedFinanceRouteChildren = {
  AuthenticatedFinanceCategoriesRoute: AuthenticatedFinanceCategoriesRoute,
  AuthenticatedFinanceCreateRoute: AuthenticatedFinanceCreateRoute,
  AuthenticatedFinanceHouseholdRoute: AuthenticatedFinanceHouseholdRoute,
  AuthenticatedFinanceProductsRoute: AuthenticatedFinanceProductsRoute,
  AuthenticatedFinanceReportsRoute: AuthenticatedFinanceReportsRoute,
  AuthenticatedFinanceRulesRoute: AuthenticatedFinanceRulesRoute,
  AuthenticatedFinanceTransactionsRoute: AuthenticatedFinanceTransactionsRoute,
  AuthenticatedFinanceIndexRoute: AuthenticatedFinanceIndexRoute,
}

const AuthenticatedFinanceRouteWithChildren =
  AuthenticatedFinanceRoute._addFileChildren(AuthenticatedFinanceRouteChildren)

interface AuthenticatedJournRouteChildren {
  AuthenticatedJournDayRoute: typeof AuthenticatedJournDayRoute
  AuthenticatedJournCalendarsRoute: typeof AuthenticatedJournCalendarsRoute
  AuthenticatedJournIndexRoute: typeof AuthenticatedJournIndexRoute
}

const AuthenticatedJournRouteChildren: AuthenticatedJournRouteChildren = {
  AuthenticatedJournDayRoute: AuthenticatedJournDayRoute,
  AuthenticatedJournCalendarsRoute: AuthenticatedJournCalendarsRoute,
  AuthenticatedJournIndexRoute: AuthenticatedJournIndexRoute,
}

const AuthenticatedJournRouteWithChildren =
  AuthenticatedJournRoute._addFileChildren(AuthenticatedJournRouteChildren)

interface AuthenticatedPetsRouteChildren {
  AuthenticatedPetsCreateRoute: typeof AuthenticatedPetsCreateRoute
  AuthenticatedPetsIndexRoute: typeof AuthenticatedPetsIndexRoute
  AuthenticatedPetsPetIdEditRoute: typeof AuthenticatedPetsPetIdEditRoute
  AuthenticatedPetsPetIdHealthRoute: typeof AuthenticatedPetsPetIdHealthRoute
  AuthenticatedPetsPetIdPhotosRoute: typeof AuthenticatedPetsPetIdPhotosRoute
  AuthenticatedPetsPetIdTutorsRoute: typeof AuthenticatedPetsPetIdTutorsRoute
  AuthenticatedPetsClinicsCreateRoute: typeof AuthenticatedPetsClinicsCreateRoute
  AuthenticatedPetsVetsCreateRoute: typeof AuthenticatedPetsVetsCreateRoute
  AuthenticatedPetsPetIdIndexRoute: typeof AuthenticatedPetsPetIdIndexRoute
  AuthenticatedPetsClinicsIndexRoute: typeof AuthenticatedPetsClinicsIndexRoute
  AuthenticatedPetsVetsIndexRoute: typeof AuthenticatedPetsVetsIndexRoute
  AuthenticatedPetsPetIdAllergiesCreateRoute: typeof AuthenticatedPetsPetIdAllergiesCreateRoute
  AuthenticatedPetsPetIdConditionsCreateRoute: typeof AuthenticatedPetsPetIdConditionsCreateRoute
  AuthenticatedPetsPetIdExamsCreateRoute: typeof AuthenticatedPetsPetIdExamsCreateRoute
  AuthenticatedPetsPetIdMedicationsCreateRoute: typeof AuthenticatedPetsPetIdMedicationsCreateRoute
  AuthenticatedPetsPetIdProceduresCreateRoute: typeof AuthenticatedPetsPetIdProceduresCreateRoute
  AuthenticatedPetsPetIdVaccinesCreateRoute: typeof AuthenticatedPetsPetIdVaccinesCreateRoute
  AuthenticatedPetsClinicsClinicIdEditRoute: typeof AuthenticatedPetsClinicsClinicIdEditRoute
  AuthenticatedPetsVetsVetIdEditRoute: typeof AuthenticatedPetsVetsVetIdEditRoute
  AuthenticatedPetsPetIdVaccinesIndexRoute: typeof AuthenticatedPetsPetIdVaccinesIndexRoute
  AuthenticatedPetsPetIdAllergiesAllergyIdEditRoute: typeof AuthenticatedPetsPetIdAllergiesAllergyIdEditRoute
  AuthenticatedPetsPetIdConditionsConditionIdEditRoute: typeof AuthenticatedPetsPetIdConditionsConditionIdEditRoute
  AuthenticatedPetsPetIdExamsExamIdEditRoute: typeof AuthenticatedPetsPetIdExamsExamIdEditRoute
  AuthenticatedPetsPetIdMedicationsMedicationIdEditRoute: typeof AuthenticatedPetsPetIdMedicationsMedicationIdEditRoute
  AuthenticatedPetsPetIdProceduresProcedureIdEditRoute: typeof AuthenticatedPetsPetIdProceduresProcedureIdEditRoute
  AuthenticatedPetsPetIdVaccinesVaccineIdEditRoute: typeof AuthenticatedPetsPetIdVaccinesVaccineIdEditRoute
  AuthenticatedPetsPetIdExamsExamIdIndexRoute: typeof AuthenticatedPetsPetIdExamsExamIdIndexRoute
}

const AuthenticatedPetsRouteChildren: AuthenticatedPetsRouteChildren = {
  AuthenticatedPetsCreateRoute: AuthenticatedPetsCreateRoute,
  AuthenticatedPetsIndexRoute: AuthenticatedPetsIndexRoute,
  AuthenticatedPetsPetIdEditRoute: AuthenticatedPetsPetIdEditRoute,
  AuthenticatedPetsPetIdHealthRoute: AuthenticatedPetsPetIdHealthRoute,
  AuthenticatedPetsPetIdPhotosRoute: AuthenticatedPetsPetIdPhotosRoute,
  AuthenticatedPetsPetIdTutorsRoute: AuthenticatedPetsPetIdTutorsRoute,
  AuthenticatedPetsClinicsCreateRoute: AuthenticatedPetsClinicsCreateRoute,
  AuthenticatedPetsVetsCreateRoute: AuthenticatedPetsVetsCreateRoute,
  AuthenticatedPetsPetIdIndexRoute: AuthenticatedPetsPetIdIndexRoute,
  AuthenticatedPetsClinicsIndexRoute: AuthenticatedPetsClinicsIndexRoute,
  AuthenticatedPetsVetsIndexRoute: AuthenticatedPetsVetsIndexRoute,
  AuthenticatedPetsPetIdAllergiesCreateRoute:
    AuthenticatedPetsPetIdAllergiesCreateRoute,
  AuthenticatedPetsPetIdConditionsCreateRoute:
    AuthenticatedPetsPetIdConditionsCreateRoute,
  AuthenticatedPetsPetIdExamsCreateRoute:
    AuthenticatedPetsPetIdExamsCreateRoute,
  AuthenticatedPetsPetIdMedicationsCreateRoute:
    AuthenticatedPetsPetIdMedicationsCreateRoute,
  AuthenticatedPetsPetIdProceduresCreateRoute:
    AuthenticatedPetsPetIdProceduresCreateRoute,
  AuthenticatedPetsPetIdVaccinesCreateRoute:
    AuthenticatedPetsPetIdVaccinesCreateRoute,
  AuthenticatedPetsClinicsClinicIdEditRoute:
    AuthenticatedPetsClinicsClinicIdEditRoute,
  AuthenticatedPetsVetsVetIdEditRoute: AuthenticatedPetsVetsVetIdEditRoute,
  AuthenticatedPetsPetIdVaccinesIndexRoute:
    AuthenticatedPetsPetIdVaccinesIndexRoute,
  AuthenticatedPetsPetIdAllergiesAllergyIdEditRoute:
    AuthenticatedPetsPetIdAllergiesAllergyIdEditRoute,
  AuthenticatedPetsPetIdConditionsConditionIdEditRoute:
    AuthenticatedPetsPetIdConditionsConditionIdEditRoute,
  AuthenticatedPetsPetIdExamsExamIdEditRoute:
    AuthenticatedPetsPetIdExamsExamIdEditRoute,
  AuthenticatedPetsPetIdMedicationsMedicationIdEditRoute:
    AuthenticatedPetsPetIdMedicationsMedicationIdEditRoute,
  AuthenticatedPetsPetIdProceduresProcedureIdEditRoute:
    AuthenticatedPetsPetIdProceduresProcedureIdEditRoute,
  AuthenticatedPetsPetIdVaccinesVaccineIdEditRoute:
    AuthenticatedPetsPetIdVaccinesVaccineIdEditRoute,
  AuthenticatedPetsPetIdExamsExamIdIndexRoute:
    AuthenticatedPetsPetIdExamsExamIdIndexRoute,
}

const AuthenticatedPetsRouteWithChildren =
  AuthenticatedPetsRoute._addFileChildren(AuthenticatedPetsRouteChildren)

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsGeneralRoute: typeof AuthenticatedSettingsGeneralRoute
  AuthenticatedSettingsProductsRoute: typeof AuthenticatedSettingsProductsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsGeneralRoute: AuthenticatedSettingsGeneralRoute,
  AuthenticatedSettingsProductsRoute: AuthenticatedSettingsProductsRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedShoppingRouteChildren {
  AuthenticatedShoppingListidRoute: typeof AuthenticatedShoppingListidRoute
  AuthenticatedShoppingIndexRoute: typeof AuthenticatedShoppingIndexRoute
}

const AuthenticatedShoppingRouteChildren: AuthenticatedShoppingRouteChildren = {
  AuthenticatedShoppingListidRoute: AuthenticatedShoppingListidRoute,
  AuthenticatedShoppingIndexRoute: AuthenticatedShoppingIndexRoute,
}

const AuthenticatedShoppingRouteWithChildren =
  AuthenticatedShoppingRoute._addFileChildren(
    AuthenticatedShoppingRouteChildren,
  )

interface AuthenticatedWorldRouteChildren {
  AuthenticatedWorldIndexRoute: typeof AuthenticatedWorldIndexRoute
}

const AuthenticatedWorldRouteChildren: AuthenticatedWorldRouteChildren = {
  AuthenticatedWorldIndexRoute: AuthenticatedWorldIndexRoute,
}

const AuthenticatedWorldRouteWithChildren =
  AuthenticatedWorldRoute._addFileChildren(AuthenticatedWorldRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedExamsRoute: typeof AuthenticatedExamsRouteWithChildren
  AuthenticatedFinanceRoute: typeof AuthenticatedFinanceRouteWithChildren
  AuthenticatedJournRoute: typeof AuthenticatedJournRouteWithChildren
  AuthenticatedMetricsRoute: typeof AuthenticatedMetricsRoute
  AuthenticatedPetsRoute: typeof AuthenticatedPetsRouteWithChildren
  AuthenticatedPomodoroRoute: typeof AuthenticatedPomodoroRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedShoppingRoute: typeof AuthenticatedShoppingRouteWithChildren
  AuthenticatedWorldRoute: typeof AuthenticatedWorldRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedExamsRoute: AuthenticatedExamsRouteWithChildren,
  AuthenticatedFinanceRoute: AuthenticatedFinanceRouteWithChildren,
  AuthenticatedJournRoute: AuthenticatedJournRouteWithChildren,
  AuthenticatedMetricsRoute: AuthenticatedMetricsRoute,
  AuthenticatedPetsRoute: AuthenticatedPetsRouteWithChildren,
  AuthenticatedPomodoroRoute: AuthenticatedPomodoroRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedShoppingRoute: AuthenticatedShoppingRouteWithChildren,
  AuthenticatedWorldRoute: AuthenticatedWorldRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AnimationRoute: AnimationRoute,
  LegalRoute: LegalRoute,
  PrivacyRoute: PrivacyRoute,
  ScanSpikeRoute: ScanSpikeRoute,
  ShareTokenRoute: ShareTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
